import { range } from "ramda";
import { Grid } from "@mui/material";

import Pill from "components/Pill";

const CategoryPillsSkeleton = ({ limit }) =>
  range(0, limit).map((index) => (
    <Grid key={`FeaturedCategories-placeholder-${index}`} item xs={6} sm={3}>
      <Pill loading />
    </Grid>
  ));

export default CategoryPillsSkeleton;
